// frontend/src/components/ProtectedRoute.jsx

import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import axios from "../axiosConfig";

/**
 * Central gate:
 * - Auth required always
 * - KYC required by default (unless requireKyc={false})
 * - If logged in but KYC not verified -> redirect to /verify
 */
const ProtectedRoute = ({ children, requireKyc = true }) => {
  const location = useLocation();

  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);
  const [kycVerified, setKycVerified] = useState(false);

  useEffect(() => {
    let mounted = true;

    axios
      .get("/whoami")
      .then((res) => {
        if (!mounted) return;

        const user = res.data?.user;
        if (user?._id) {
          setAuthenticated(true);
          setKycVerified(Boolean(user.isKycVerified));
        } else {
          setAuthenticated(false);
          setKycVerified(false);
        }
      })
      .catch(() => {
        if (!mounted) return;
        setAuthenticated(false);
        setKycVerified(false);
      })
      .finally(() => {
        if (!mounted) return;
        setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, []);

  if (loading) {
    return <div className="pt-20 text-center">Checking authentication…</div>;
  }

  // Not logged in -> login
  if (!authenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  // Logged in but KYC not verified -> force /verify (unless requireKyc is disabled)
  if (requireKyc && !kycVerified) {
    // Avoid redirect loop if already on verify/profile
    if (location.pathname !== "/verify" && location.pathname !== "/profile") {
      return <Navigate to="/verify" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
